module.exports = __webpack_public_path__ + "media/images/email_icon-4d489c1a914e49ac5569f0bbae1111bc.png";